import { render, staticRenderFns } from "./ProductIntegrationDiagnosticCmp.vue?vue&type=template&id=72f1117e&scoped=true&"
import script from "./ProductIntegrationDiagnosticCmp.vue?vue&type=script&lang=js&"
export * from "./ProductIntegrationDiagnosticCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntegrationDiagnosticCmp.vue?vue&type=style&index=0&id=72f1117e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1117e",
  null
  
)

export default component.exports